





























import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessCreditCheckReview from './Update/BusinessCreditCheckReview.vue';

@Component({
  components: {
    BusinessCreditCheckReview,
  },
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
  },
})
export default class BusinessCreditCheckResult extends Vue {
  isMounted = false;
  activeBusiness!: Model;
  business!: Model;

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  isApiFetch = {
    isApiFetchBusinessFinished: false,
    isApiFetchCountryFinished: false,
  };

  beforeMount() {
    this.$store
      .dispatch('Business/fetch', {
        businessOid: this.activeBusiness.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      })
      .then(() => {
        this.isApiFetch['isApiFetchBusinessFinished'] = true;
      });

    if (!this.countries.length) {
      this.$store
        .dispatch('Country/fetchList', {
          params: {
            expand: ['states'],
          },
        })
        .then(() => {
          this.isApiFetch['isApiFetchCountryFinished'] = true;
        });
    } else {
      this.isApiFetch['isApiFetchCountryFinished'] = true;
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }
}
